import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const Bold: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.72385 4.5C7.09405 4.5 6.5835 4.97969 6.5835 5.57143V18.4286C6.5835 19.0203 7.09405 19.5 7.72385 19.5H12.5703C15.247 19.5 17.4168 17.4613 17.4168 14.9464C17.4168 13.2066 16.3783 11.6946 14.8518 10.928C15.3884 10.2566 15.7063 9.42209 15.7063 8.51786C15.7063 6.29885 13.7917 4.5 11.43 4.5H7.72385ZM11.43 10.3929C12.5321 10.3929 13.4256 9.55339 13.4256 8.51786C13.4256 7.48232 12.5321 6.64286 11.43 6.64286H8.8642V10.3929H11.43ZM8.8642 12.5357V17.3571H12.5703C13.9874 17.3571 15.1361 16.2778 15.1361 14.9464C15.1361 13.615 13.9874 12.5357 12.5703 12.5357H8.8642Z"
      fill="currentColor"
    />
  </svg>
);
